import { render, staticRenderFns } from "./specialCategories.vue?vue&type=template&id=5bcd45dc&scoped=true"
import script from "./specialCategories.vue?vue&type=script&lang=js"
export * from "./specialCategories.vue?vue&type=script&lang=js"
import style0 from "./specialCategories.vue?vue&type=style&index=0&id=5bcd45dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcd45dc",
  null
  
)

export default component.exports